import type { Middleware } from '@reduxjs/toolkit';
import { api } from '@shared/api/api';
import { apiBlob } from '@shared/api/api-blob';

import { rtkQueryErrorHandler } from './error-handler';

export const middlewares: Array<Middleware> = [
  api.middleware,
  apiBlob.middleware,
  rtkQueryErrorHandler,
];
